import React from "react";
import { useTranslation } from "react-i18next";

type RequestType = "deliver" | "pickup";

interface RequestTypeSelectionProps {
  requestType: RequestType | null;
  isCustomLicense: boolean;
  onRequestTypeChange: (type: RequestType) => void;
  predictedReason?: string | null; // Allow null values
}

export const RequestTypeSelection: React.FC<RequestTypeSelectionProps> = ({
  requestType,
  isCustomLicense,
  onRequestTypeChange,
  predictedReason,
}) => {
  const { t } = useTranslation("common");

  return (
    <div className="delivery-type-container mt-3">
      <label className="form-label fw-bold">
        {t("What would you like us to do?")}
      </label>

      {predictedReason && (
        <div className="mb-2">
          <small className="text-success">
            <i className="fas fa-lightbulb me-1"></i>
            {t("auto_selected_type_because", {
              type: t(
                requestType === "pickup" ? "Pickup" : "Delivery",
              ).toLowerCase(),
              reason: predictedReason,
            })}
          </small>
        </div>
      )}

      <div className="radio-options">
        {/* Only show Delivery option if not a new car */}
        {!isCustomLicense && (
          <div
            className={`radio-option-box ${
              requestType === "deliver" ? "selected" : ""
            }`}
            onClick={() => onRequestTypeChange("deliver")}
          >
            <label className="radio-label">
              <input
                type="radio"
                name="deliveryType"
                value="deliver"
                checked={requestType === "deliver"}
                onChange={(e) =>
                  onRequestTypeChange(e.target.value as "deliver")
                }
              />
              <div>
                <strong>{t("Delivery")}</strong>
                <div className="text-muted small">
                  {t("Delivery option description")}
                </div>
              </div>
            </label>
          </div>
        )}

        <div
          className={`radio-option-box ${
            requestType === "pickup" ? "selected" : ""
          }`}
          onClick={() => {
            onRequestTypeChange("pickup");
          }}
        >
          <label className="radio-label">
            <input
              type="radio"
              name="deliveryType"
              value="pickup"
              checked={requestType === "pickup"}
              onChange={(e) => {
                onRequestTypeChange(e.target.value as "pickup");
              }}
            />
            <div>
              <strong>{t("Pickup")}</strong>
              <div className="text-muted small">
                {t("Pickup option description")}
              </div>
            </div>
          </label>
        </div>
      </div>
    </div>
  );
};
